
import { mapState } from 'vuex'
import { formatPrice } from '@/utils/helpers'
import analytics from '~/mixins.js/analytics'

export default {
  filters: {
    formatPrice
  },
  components: {
    'id-diagram-lazy-promo-box': () => import('~/components/diagram/lazy/PromoBox.vue')
  },
  mixins: [
    analytics
  ],
  props: {
    inCart: Boolean,
    inWishlist: Boolean,
    cartItem: { type: Object }
  },
  data () {
    return {
      promoCode: null,
      isLoading: false,
      selectedLicense: null,
      isChanging: false
    }
  },
  computed: {
    ...mapState({ licenses: state => state.checkout.licenses }),
    hasDiscount () {
      return this.cartItem.discount > 0
    }
  },
  methods: {
    handleChange (isChanging) {
      this.isChanging = isChanging
    },
    async loadDiagram () {
      const diagram = this.cartItem.diagram
      diagram.for_sale = true
      this.trackEvent('Checkout modal', 'Show', diagram.name)
      await this.$store.dispatch(
        'checkout/setItemPreview',
        {
          visible: true,
          diagram: this.cartItem.diagram,
          $backend: this.$backend
        }
      )
    }
  }
}
